"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Evexia API
 * OpenAPI Spec for Evexia APIs
 *
 * The version of the OpenAPI document: 1.0
 * Contact: ch_engineering@calm.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircleApi = exports.CircleApiFactory = exports.CircleApiFp = exports.CircleApiAxiosParamCreator = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
// @ts-ignore
const base_1 = require("../base");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
/**
 * CircleApi - axios parameter creator
 * @export
 */
const CircleApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Creates a circle relationship. This endpoint requires admin permissions. |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @param {number} recipientId A ID of the recipient self circle
         * @param {CircleCreateRelationshipRequest} circleCreateRelationshipRequest Create circle relationship request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCircleRelationshipV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, circleCreateRelationshipRequest, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('createCircleRelationshipV1', 'recipientId', recipientId);
            // verify required parameter 'circleCreateRelationshipRequest' is not null or undefined
            (0, common_1.assertParamExists)('createCircleRelationshipV1', 'circleCreateRelationshipRequest', circleCreateRelationshipRequest);
            const localVarPath = `/v1/circles/{recipient_id}/relationships`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/circles/{recipient_id}/relationships`,
                sdkMethod: 'createCircleRelationshipV1',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(circleCreateRelationshipRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | d |
         * @summary Deletes a circle and all resources associated with it: activities, documents, medications, and polls.
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCircle: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, circleAuthorizationToken }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('deleteCircle', 'recipientId', recipientId);
            const localVarPath = `/v1/circles/{recipient_id}`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/circles/{recipient_id}`,
                sdkMethod: 'deleteCircle',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Deletes a circle relationship by caregiver user id. Permissions required: |Feature|Dataclass|Permission| |-------|---------|----------| | - | careteam | d |
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} caregiverId Circle Relationship Caregiver User ID.
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCircleRelationshipByCaregiverV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, caregiverId, circleAuthorizationToken, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('deleteCircleRelationshipByCaregiverV1', 'recipientId', recipientId);
            // verify required parameter 'caregiverId' is not null or undefined
            (0, common_1.assertParamExists)('deleteCircleRelationshipByCaregiverV1', 'caregiverId', caregiverId);
            const localVarPath = `/v1/circles/{recipient_id}/caregivers/{caregiver_id}`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'caregiver_id'}}`, encodeURIComponent(String(caregiverId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/circles/{recipient_id}/caregivers/{caregiver_id}`,
                sdkMethod: 'deleteCircleRelationshipByCaregiverV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | careteam | d |
         * @summary Removes other relationship from a circle if there is permissions to do so. A member with s permission can remove anyone and a member with d permission can remove non s relationships.
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} relationshipId Circle Relationship ID.
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCircleRelationshipForOthersV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, relationshipId, circleAuthorizationToken, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('deleteCircleRelationshipForOthersV1', 'recipientId', recipientId);
            // verify required parameter 'relationshipId' is not null or undefined
            (0, common_1.assertParamExists)('deleteCircleRelationshipForOthersV1', 'relationshipId', relationshipId);
            const localVarPath = `/v1/circles/{recipient_id}/relationships/{relationship_id}`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'relationship_id'}}`, encodeURIComponent(String(relationshipId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/circles/{recipient_id}/relationships/{relationship_id}`,
                sdkMethod: 'deleteCircleRelationshipForOthersV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | e |
         * @summary Deletes a circle permanently and all resources associated with it
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expungeCircleV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, circleAuthorizationToken }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('expungeCircleV1', 'recipientId', recipientId);
            const localVarPath = `/v1/circles/{recipient_id}/expunge`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/circles/{recipient_id}/expunge`,
                sdkMethod: 'expungeCircleV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | w |
         * @summary Extend the sponsorship for the recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} partnerId The ID of the partner
         * @param {string} sponsorshipId The ID of the sponsorship
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extendSponsorship: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, partnerId, sponsorshipId, body, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('extendSponsorship', 'recipientId', recipientId);
            // verify required parameter 'partnerId' is not null or undefined
            (0, common_1.assertParamExists)('extendSponsorship', 'partnerId', partnerId);
            // verify required parameter 'sponsorshipId' is not null or undefined
            (0, common_1.assertParamExists)('extendSponsorship', 'sponsorshipId', sponsorshipId);
            const localVarPath = `/v1/circles/{recipient_id}/partners/{partner_id}/sponsorships/{sponsorship_id}/extend`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'partner_id'}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${'sponsorship_id'}}`, encodeURIComponent(String(sponsorshipId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/circles/{recipient_id}/partners/{partner_id}/sponsorships/{sponsorship_id}/extend`,
                sdkMethod: 'extendSponsorship',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Returns a circle by recipient id
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {boolean} [includePastRelation] when true, the result will contain relationships where a user left the circle.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCircleById: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, circleAuthorizationToken, includePastRelation, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('getCircleById', 'recipientId', recipientId);
            const localVarPath = `/v1/circles/{recipient_id}`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (includePastRelation !== undefined) {
                localVarQueryParameter['include_past_relation'] =
                    includePastRelation;
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/circles/{recipient_id}`,
                sdkMethod: 'getCircleById',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Get cohort configurations for a circle
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {boolean} [includeDeleted] when true, the result will contain soft deleted circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCircleCohortV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, circleAuthorizationToken, includeDeleted, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('getCircleCohortV1', 'recipientId', recipientId);
            const localVarPath = `/v1/circles/{recipient_id}/cohort`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (includeDeleted !== undefined) {
                localVarQueryParameter['include_deleted'] = includeDeleted;
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/circles/{recipient_id}/cohort`,
                sdkMethod: 'getCircleCohortV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * The endpoint populates the information first using member\'s self circle information. If the information is not available on self circle, then it calls the identity service to fetch account level information and uses that. |Feature|Dataclass|Permission| |-------|---------|----------| | - | careteam | r |
         * @summary Returns members of a circle which includes recipient & caregivers
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {boolean} [includePastMembers] Includes past members who were removed from caregiver team. Defaults to false.
         * @param {boolean} [includeDeleted] when true, the result will contain soft deleted circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCircleMembers: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, circleAuthorizationToken, includePastMembers, includeDeleted, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('getCircleMembers', 'recipientId', recipientId);
            const localVarPath = `/v1/circles/{recipient_id}/members`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (includePastMembers !== undefined) {
                localVarQueryParameter['include_past_members'] =
                    includePastMembers;
            }
            if (includeDeleted !== undefined) {
                localVarQueryParameter['include_deleted'] = includeDeleted;
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/circles/{recipient_id}/members`,
                sdkMethod: 'getCircleMembers',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Get unsponsored config
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCircleUnsponsoredConfig: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ acceptLanguage }, options = {}) {
            const localVarPath = `/v1/circles/configs/unsponsored`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/circles/configs/unsponsored`,
                sdkMethod: 'getCircleUnsponsoredConfig',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Returns circles for the current user
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} [userId] This field can be used if the target user is different than the current user. Requires read permission. If ignored returns circles for the current user.
         * @param {string} [cohort] If provided, the result will contain circles from that cohort only.
         * @param {boolean} [includePastRelation] when true, the result will contain relationships where a user left the circle.
         * @param {boolean} [includeDeleted] When set true, the result will contain deleted circles in which the user is ACR. Do not pass the variable unless there is a specific requirement to display soft deleted circles.
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [forceRefreshSponsor] Force refresh of circle sponsorships
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCirclesV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp, userId, cohort, includePastRelation, includeDeleted, acceptLanguage, forceRefreshSponsor, }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('getCirclesV1', 'rHGApp', rHGApp);
            const localVarPath = `/v1/circles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }
            if (cohort !== undefined) {
                localVarQueryParameter['cohort'] = cohort;
            }
            if (includePastRelation !== undefined) {
                localVarQueryParameter['include_past_relation'] =
                    includePastRelation;
            }
            if (includeDeleted !== undefined) {
                localVarQueryParameter['include_deleted'] = includeDeleted;
            }
            if (forceRefreshSponsor !== undefined) {
                localVarQueryParameter['forceRefreshSponsor'] =
                    forceRefreshSponsor;
            }
            if (rHGApp !== undefined && rHGApp !== null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/circles`,
                sdkMethod: 'getCirclesV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Returns the cohort configuration.
         * @param {string} name The cohort name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCohortByNameV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ name }, options = {}) {
            // verify required parameter 'name' is not null or undefined
            (0, common_1.assertParamExists)('getCohortByNameV1', 'name', name);
            const localVarPath = `/v1/cohorts/{name}`.replace(`{${'name'}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/cohorts/{name}`,
                sdkMethod: 'getCohortByNameV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * The API returns config for the most recent sponsorship for the recipient along with sponsor details. Note that the most recent sponsorship can be terminated due to eligibility loss. The API returns the most recent sponsorship data to allow for the copy circle flow that needs to be triggered after the loss of sponsorship. |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Returns details about the most recent sponsorship
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMostRecentSponsorship: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, acceptLanguage, circleAuthorizationToken, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('getMostRecentSponsorship', 'recipientId', recipientId);
            const localVarPath = `/v1/circles/{recipient_id}/sponsorships`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/circles/{recipient_id}/sponsorships`,
                sdkMethod: 'getMostRecentSponsorship',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - | This endpoint will return the partner member for the given partner id and search criteria. This endpoint is only accessible to admin users. Note that every partner has a different set of search criteria.  Search criteria can be by: - validation fields like partnerId + (email, firstName, lastName, dob, subscriberId). - partner specific fields like partnerId + (memberId).
         * @summary Gets Partners Member as admin by partner id and search criteria.
         * @param {string} partnerId The ID of the partner
         * @param {string} [memberId] Id of the member to search
         * @param {string} [email] Email of the member to search
         * @param {string} [firstName] First name of the member to search
         * @param {string} [lastName] Last name of the member to search
         * @param {string} [dob] Date of birth of the member to search.  full-date notation as defined by [RFC 3339, section 5.6](https://datatracker.ietf.org/doc/html/rfc3339#section-5.6), for example, 2017-07-21
         * @param {string} [subscriberId] SubscriberId of the member to search.
         * @param {string} [partnerMemberId] Id of the member in the partner system saved in our DB to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerMemberAsAdmin: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ partnerId, memberId, email, firstName, lastName, dob, subscriberId, partnerMemberId, }, options = {}) {
            // verify required parameter 'partnerId' is not null or undefined
            (0, common_1.assertParamExists)('getPartnerMemberAsAdmin', 'partnerId', partnerId);
            const localVarPath = `/v1/partners/{partner_id}/members/search`.replace(`{${'partner_id'}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (memberId !== undefined) {
                localVarQueryParameter['member_id'] = memberId;
            }
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            if (firstName !== undefined) {
                localVarQueryParameter['first_name'] = firstName;
            }
            if (lastName !== undefined) {
                localVarQueryParameter['last_name'] = lastName;
            }
            if (dob !== undefined) {
                localVarQueryParameter['dob'] =
                    dob instanceof Date
                        ? dob.toISOString().substr(0, 10)
                        : dob;
            }
            if (subscriberId !== undefined) {
                localVarQueryParameter['subscriber_id'] = subscriberId;
            }
            if (partnerMemberId !== undefined) {
                localVarQueryParameter['partner_member_id'] = partnerMemberId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/partners/{partner_id}/members/search`,
                sdkMethod: 'getPartnerMemberAsAdmin',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Returns Partners config by uniq code
         * @param {string} uniqCode Partner Unique Code
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnersConfigByUniqCode: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ uniqCode, recipientId, acceptLanguage, circleAuthorizationToken, }, options = {}) {
            // verify required parameter 'uniqCode' is not null or undefined
            (0, common_1.assertParamExists)('getPartnersConfigByUniqCode', 'uniqCode', uniqCode);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('getPartnersConfigByUniqCode', 'recipientId', recipientId);
            const localVarPath = `/v1/circles/{recipient_id}/partners/codes/{uniq_code}`
                .replace(`{${'uniq_code'}}`, encodeURIComponent(String(uniqCode)))
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/circles/{recipient_id}/partners/codes/{uniq_code}`,
                sdkMethod: 'getPartnersConfigByUniqCode',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |  This endpoint will return the partner config for the given uniq code. This endpoint is only accessible to admin users. After you got the partner config, you can use the partner_id to call the other endpoints. E.g. [/v1/partners/{partner_id}/members/search](https://apidoc.evexiaapp.site/#/circle/getPartnerMemberAsAdmin) to find member.
         * @summary Returns Partners config as admin by uniq code
         * @param {string} uniqCode Partner Unique Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnersConfigByUniqCodeAsAdmin: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ uniqCode }, options = {}) {
            // verify required parameter 'uniqCode' is not null or undefined
            (0, common_1.assertParamExists)('getPartnersConfigByUniqCodeAsAdmin', 'uniqCode', uniqCode);
            const localVarPath = `/v1/partners/codes/{uniq_code}`.replace(`{${'uniq_code'}}`, encodeURIComponent(String(uniqCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/partners/codes/{uniq_code}`,
                sdkMethod: 'getPartnersConfigByUniqCodeAsAdmin',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Returns a list of referrals associated with the query params
         * @param {number} recipientId A ID of the recipient self circle
         * @param {Array<string>} referralId The Referral ID array sent in the form referral_id&#x3D;a&amp;referral_id&#x3D;b&amp;..
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {string} [partnerId] The ID of the partner, required to fetch sponsored referral, else unsponsored referral returned.
         * @param {string} [sponsorshipConfigId] The Sponsorship Config ID, required to fetch sponsored referral, else unsponsored referral returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferrals: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, referralId, acceptLanguage, circleAuthorizationToken, partnerId, sponsorshipConfigId, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('getReferrals', 'recipientId', recipientId);
            // verify required parameter 'referralId' is not null or undefined
            (0, common_1.assertParamExists)('getReferrals', 'referralId', referralId);
            const localVarPath = `/v1/circles/{recipient_id}/referrals`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (referralId) {
                localVarQueryParameter['referral_id'] = referralId;
            }
            if (partnerId !== undefined) {
                localVarQueryParameter['partner_id'] = partnerId;
            }
            if (sponsorshipConfigId !== undefined) {
                localVarQueryParameter['sponsorship_config_id'] =
                    sponsorshipConfigId;
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/circles/{recipient_id}/referrals`,
                sdkMethod: 'getReferrals',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Get health resources for the given Circle\'s Sponsorship
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {Array<string>} [themes] List of themes to filter the resources by.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResources: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, acceptLanguage, circleAuthorizationToken, themes, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('getResources', 'recipientId', recipientId);
            const localVarPath = `/v1/circles/{recipient_id}/resources`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (themes) {
                localVarQueryParameter['themes'] = themes;
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/circles/{recipient_id}/resources`,
                sdkMethod: 'getResources',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |  This endpoint will return an array of sponsors for the given member id. This endpoint is only accessible to admin users. After you got the list of sponsors, you may attach the response to other admin endpoints.
         * @summary Returns non-removed Sponsors for a given Member ID
         * @param {string} memberId The ID of the member
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSponsorsByMemberIDAsAdmin: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ memberId }, options = {}) {
            // verify required parameter 'memberId' is not null or undefined
            (0, common_1.assertParamExists)('getSponsorsByMemberIDAsAdmin', 'memberId', memberId);
            const localVarPath = `/v1/sponsorships/members/{member_id}`.replace(`{${'member_id'}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/sponsorships/members/{member_id}`,
                sdkMethod: 'getSponsorsByMemberIDAsAdmin',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Returns circle by id for the user.
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} userId This field can be used if the target user is different than the current user. Requires read permission.
         * @param {boolean} [includePastRelation] when true, the result will contain relationships where a user left the circle.
         * @param {boolean} [includeDeleted] when true, the result will contain soft deleted circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersCirclesRecipientV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, userId, includePastRelation, includeDeleted, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('getUsersCirclesRecipientV1', 'recipientId', recipientId);
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('getUsersCirclesRecipientV1', 'userId', userId);
            const localVarPath = `/v1/circles/users/{user_id}/circles/{recipient_id}`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'user_id'}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (includePastRelation !== undefined) {
                localVarQueryParameter['include_past_relation'] =
                    includePastRelation;
            }
            if (includeDeleted !== undefined) {
                localVarQueryParameter['include_deleted'] = includeDeleted;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/circles/users/{user_id}/circles/{recipient_id}`,
                sdkMethod: 'getUsersCirclesRecipientV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Returns circle summaries for the current user
         * @param {string} userId This field can be used if the target user is different than the current user. Requires read permission. If ignored returns circles for the current user.
         * @param {string} [cohort] If provided, the result will contain circles from that cohort only.
         * @param {'true' | 'false'} [includeRecipientIdsJWT] If true the response contains recipient IDs JWT which can be used for batch queries.
         * @param {boolean} [includeDeleted] when true, the result will contain soft deleted circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersCirclesV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId, cohort, includeRecipientIdsJWT, includeDeleted, }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('getUsersCirclesV1', 'userId', userId);
            const localVarPath = `/v1/circles/users/{user_id}/circles`.replace(`{${'user_id'}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (cohort !== undefined) {
                localVarQueryParameter['cohort'] = cohort;
            }
            if (includeRecipientIdsJWT !== undefined) {
                localVarQueryParameter['includeRecipientIdsJWT'] =
                    includeRecipientIdsJWT;
            }
            if (includeDeleted !== undefined) {
                localVarQueryParameter['include_deleted'] = includeDeleted;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/circles/users/{user_id}/circles`,
                sdkMethod: 'getUsersCirclesV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Removes a relationship representing the member from a circle for the member calling the endpoint
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveCircleRelationship: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('leaveCircleRelationship', 'recipientId', recipientId);
            const localVarPath = `/v1/circles/{recipient_id}/relationships/self`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/circles/{recipient_id}/relationships/self`,
                sdkMethod: 'leaveCircleRelationship',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | careteam | u |
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} relationshipId Circle Relationship ID.
         * @param {CirclePatchRelationshipRequest} circlePatchRelationshipRequest Patch Circle Relationship
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCircleRelationshipV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, relationshipId, circlePatchRelationshipRequest, circleAuthorizationToken, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('patchCircleRelationshipV1', 'recipientId', recipientId);
            // verify required parameter 'relationshipId' is not null or undefined
            (0, common_1.assertParamExists)('patchCircleRelationshipV1', 'relationshipId', relationshipId);
            // verify required parameter 'circlePatchRelationshipRequest' is not null or undefined
            (0, common_1.assertParamExists)('patchCircleRelationshipV1', 'circlePatchRelationshipRequest', circlePatchRelationshipRequest);
            const localVarPath = `/v1/circles/{recipient_id}/relationships/{relationship_id}`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'relationship_id'}}`, encodeURIComponent(String(relationshipId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/circles/{recipient_id}/relationships/{relationship_id}`,
                sdkMethod: 'patchCircleRelationshipV1',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(circlePatchRelationshipRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Allows caregivers to edit certain fields of their circle relationship. |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @param {number} recipientId A ID of the recipient self circle
         * @param {CirclePatchSelfRelationshipRequest} circlePatchSelfRelationshipRequest Patch Self Circle Relationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchSelfCircleRelationshipV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, circlePatchSelfRelationshipRequest, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('patchSelfCircleRelationshipV1', 'recipientId', recipientId);
            // verify required parameter 'circlePatchSelfRelationshipRequest' is not null or undefined
            (0, common_1.assertParamExists)('patchSelfCircleRelationshipV1', 'circlePatchSelfRelationshipRequest', circlePatchSelfRelationshipRequest);
            const localVarPath = `/v1/circles/{recipient_id}/relationships/self`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/circles/{recipient_id}/relationships/self`,
                sdkMethod: 'patchSelfCircleRelationshipV1',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(circlePatchSelfRelationshipRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Creates a circle with current user as the specified role.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {CircleCreateCircleRequest} circleCreateCircleRequest Create circle request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCirclesV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp, circleCreateCircleRequest }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('postCirclesV1', 'rHGApp', rHGApp);
            // verify required parameter 'circleCreateCircleRequest' is not null or undefined
            (0, common_1.assertParamExists)('postCirclesV1', 'circleCreateCircleRequest', circleCreateCircleRequest);
            const localVarPath = `/v1/circles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (rHGApp !== undefined && rHGApp !== null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/circles`,
                sdkMethod: 'postCirclesV1',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(circleCreateCircleRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | role | u |
         * @summary Updates the role of the user to the new role in the circle.
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} relationshipId The caregivers relationship id whose role needs to be changed.
         * @param {string} newRole The new role that user should belong to. Only one of the roles allowed in the circle can be used.
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCircleUserRoleV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, relationshipId, newRole, circleAuthorizationToken, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('updateCircleUserRoleV1', 'recipientId', recipientId);
            // verify required parameter 'relationshipId' is not null or undefined
            (0, common_1.assertParamExists)('updateCircleUserRoleV1', 'relationshipId', relationshipId);
            // verify required parameter 'newRole' is not null or undefined
            (0, common_1.assertParamExists)('updateCircleUserRoleV1', 'newRole', newRole);
            const localVarPath = `/v1/circles/{recipient_id}/relationships/{relationship_id}/roles/{new_role}`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'relationship_id'}}`, encodeURIComponent(String(relationshipId)))
                .replace(`{${'new_role'}}`, encodeURIComponent(String(newRole)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/circles/{recipient_id}/relationships/{relationship_id}/roles/{new_role}`,
                sdkMethod: 'updateCircleUserRoleV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | w |
         * @summary Updates a user\'s consents
         * @param {number} recipientId A ID of the recipient self circle
         * @param {CircleUpdateUserConsentRequest} circleUpdateUserConsentRequest Consents to update
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserConsents: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, circleUpdateUserConsentRequest, circleAuthorizationToken, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('updateUserConsents', 'recipientId', recipientId);
            // verify required parameter 'circleUpdateUserConsentRequest' is not null or undefined
            (0, common_1.assertParamExists)('updateUserConsents', 'circleUpdateUserConsentRequest', circleUpdateUserConsentRequest);
            const localVarPath = `/v1/circles/{recipient_id}/consents`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/circles/{recipient_id}/consents`,
                sdkMethod: 'updateUserConsents',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(circleUpdateUserConsentRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | u |
         * @summary Changes a sponsor for a recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} partnerId The ID of the partner
         * @param {CircleChangeSponsorshipRequest} circleChangeSponsorshipRequest Change sponsorship request.
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ChangeSponsor: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, partnerId, circleChangeSponsorshipRequest, circleAuthorizationToken, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v1ChangeSponsor', 'recipientId', recipientId);
            // verify required parameter 'partnerId' is not null or undefined
            (0, common_1.assertParamExists)('v1ChangeSponsor', 'partnerId', partnerId);
            // verify required parameter 'circleChangeSponsorshipRequest' is not null or undefined
            (0, common_1.assertParamExists)('v1ChangeSponsor', 'circleChangeSponsorshipRequest', circleChangeSponsorshipRequest);
            const localVarPath = `/v1/circles/{recipient_id}/partners/{partner_id}/sponsorship`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'partner_id'}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/circles/{recipient_id}/partners/{partner_id}/sponsorship`,
                sdkMethod: 'v1ChangeSponsor',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(circleChangeSponsorshipRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Admin Only - Sets the cohort for a circle. Admin only access
         * @param {number} recipientId A ID of the recipient self circle
         * @param {CircleUpdateCircleRequest} circleUpdateCircleRequest Create circle request
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1CirclesRecipientIdPatch: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, circleUpdateCircleRequest, circleAuthorizationToken, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v1CirclesRecipientIdPatch', 'recipientId', recipientId);
            // verify required parameter 'circleUpdateCircleRequest' is not null or undefined
            (0, common_1.assertParamExists)('v1CirclesRecipientIdPatch', 'circleUpdateCircleRequest', circleUpdateCircleRequest);
            const localVarPath = `/v1/circles/{recipient_id}`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/circles/{recipient_id}`,
                sdkMethod: 'v1CirclesRecipientIdPatch',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(circleUpdateCircleRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * The API does the following: 1a. saves provided consent in the post body to the recipient_id 1b. copies the circle data of recipient_id to a new_recipient_id, and saves the parent recipient_id in DB for the new_recipient_id. 1c. soft deletes the data of recipient_id 2. call copy endpoint on all the services with old and new recipient_id  If there is an error in step 2, it tries to revert the step 1. Any error in revert operation is ignored and leaves the user data in inconsistent state that needs to be handled manually.  On success operation, the clients can call the getCircles API to fetch latest circle data and tokens as usual. |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | c |
         * @summary copyCircle
         * @param {number} recipientId A ID of the recipient self circle
         * @param {CircleCopyRequest} circleCopyRequest
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1CopyCircle: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, circleCopyRequest, circleAuthorizationToken, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v1CopyCircle', 'recipientId', recipientId);
            // verify required parameter 'circleCopyRequest' is not null or undefined
            (0, common_1.assertParamExists)('v1CopyCircle', 'circleCopyRequest', circleCopyRequest);
            const localVarPath = `/v1/circles/{recipient_id}/copy`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/circles/{recipient_id}/copy`,
                sdkMethod: 'v1CopyCircle',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(circleCopyRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | d |
         * @summary Deletes a sponsor for a recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} partnerId The ID of the partner
         * @param {string} sponsorshipId The ID of the sponsorship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DeleteSponsor: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, partnerId, sponsorshipId }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v1DeleteSponsor', 'recipientId', recipientId);
            // verify required parameter 'partnerId' is not null or undefined
            (0, common_1.assertParamExists)('v1DeleteSponsor', 'partnerId', partnerId);
            // verify required parameter 'sponsorshipId' is not null or undefined
            (0, common_1.assertParamExists)('v1DeleteSponsor', 'sponsorshipId', sponsorshipId);
            const localVarPath = `/v1/circles/{recipient_id}/partners/{partner_id}/sponsorships/{sponsorship_config_id}`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'partner_id'}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${'sponsorship_id'}}`, encodeURIComponent(String(sponsorshipId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/circles/{recipient_id}/partners/{partner_id}/sponsorships/{sponsorship_config_id}`,
                sdkMethod: 'v1DeleteSponsor',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * The API refreshes sponsorship by fetching new member data from eligibility source. The cohort/perms can changed. The recipient can lose sponsorship in which case the response will have no sponsor object on the circle. The API is cached and uses cached data till expiry, unless forceRefresh flag is used. |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | w |
         * @summary Refreshes sponsor for recipient
         * @param {string} partnerId The ID of the partner
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [forceRefresh] Force refresh by excluding cache
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RefreshSponsorship: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ partnerId, recipientId, acceptLanguage, forceRefresh, body, }, options = {}) {
            // verify required parameter 'partnerId' is not null or undefined
            (0, common_1.assertParamExists)('v1RefreshSponsorship', 'partnerId', partnerId);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v1RefreshSponsorship', 'recipientId', recipientId);
            const localVarPath = `/v1/circles/{recipient_id}/partners/{partner_id}/sponsorships/refresh`
                .replace(`{${'partner_id'}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (forceRefresh !== undefined) {
                localVarQueryParameter['forceRefresh'] = forceRefresh;
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/circles/{recipient_id}/partners/{partner_id}/sponsorships/refresh`,
                sdkMethod: 'v1RefreshSponsorship',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Validates the given input based on the type of eligibility source. Determines the sponsorship based on partner and assigns one to the member. The Sponsorship Config ID in the response can be used to get the partner+sponsorship level configurations like logo etc. The API can be called in following scenarios:  1. User is registering for the first time and wants a sponsor.  2. User has already registered as d2c cohort and is now trying to pickup their first sponsorship.  3. User has already registered as sponsored cohort and is now trying to change their sponsorship to something else.  For invitation-based sponsorships, the request body should contain an `invite_code` validation field: { \"name\":\"invite_code\", \"value\":\"1D7EXXIPO\" }  |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | w |
         * @summary validates input and assign sponsorship
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} partnerId The ID of the partner
         * @param {CircleValidateAndAssignSponsorshipRequest} circleValidateAndAssignSponsorshipRequest Invite request
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ValidateAndAssignSponsorship: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, partnerId, circleValidateAndAssignSponsorshipRequest, circleAuthorizationToken, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v1ValidateAndAssignSponsorship', 'recipientId', recipientId);
            // verify required parameter 'partnerId' is not null or undefined
            (0, common_1.assertParamExists)('v1ValidateAndAssignSponsorship', 'partnerId', partnerId);
            // verify required parameter 'circleValidateAndAssignSponsorshipRequest' is not null or undefined
            (0, common_1.assertParamExists)('v1ValidateAndAssignSponsorship', 'circleValidateAndAssignSponsorshipRequest', circleValidateAndAssignSponsorshipRequest);
            const localVarPath = `/v1/circles/{recipient_id}/partners/{partner_id}/sponsorship`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'partner_id'}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/circles/{recipient_id}/partners/{partner_id}/sponsorship`,
                sdkMethod: 'v1ValidateAndAssignSponsorship',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(circleValidateAndAssignSponsorshipRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Validates whether the given data is eligible for sponsorship by the partner based on the Partner\'s Eligiblty Source. This endpoint does not assign a sponsorship to the user, and is only used to check for sponsorship eligibility.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary validates user eligibilty for partner sponsorship
         * @param {string} partnerId The ID of the partner
         * @param {CircleSponsorshipEligibilityRequest} circleSponsorshipEligibilityRequest Eligibility Validation Request
         * @param {boolean} [verifyExistingSponsorship] This field is used to check if the target user is different than the current redeemed user. Requires read permission. If ignored returns member for the current user.
         * @param {boolean} [implied] When true, the API will upsert a record for eligibility using the provided eligibility fields. The partner_member_id/partner_user_id is the subject/user_id of the user who called the API. The eligibility fields from the ssoData in the Auth Token is used and not the one sent in the POST body to make sure the data is not tampered with. For admin, the eligibility fields are taken from the POST body and a partner_member_id query param can be sent.
         * @param {string} [partnerMemberId] Admin only. When implied&#x3D;true, the API will upsert a record for eligibility using the provided eligibility fields. The partner_member_id/partner_user_id is the subject/user_id of the user who called the API. The eligibility fields from the ssoData in the Auth Token is used and not the one sent in the POST body to make sure the data is not tampered with. For admin, the eligibility fields are taken from the POST body and a partner_member_id query param is used as partner_user_id/partner_member_id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ValidatePartnerEligibility: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ partnerId, circleSponsorshipEligibilityRequest, verifyExistingSponsorship, implied, partnerMemberId, }, options = {}) {
            // verify required parameter 'partnerId' is not null or undefined
            (0, common_1.assertParamExists)('v1ValidatePartnerEligibility', 'partnerId', partnerId);
            // verify required parameter 'circleSponsorshipEligibilityRequest' is not null or undefined
            (0, common_1.assertParamExists)('v1ValidatePartnerEligibility', 'circleSponsorshipEligibilityRequest', circleSponsorshipEligibilityRequest);
            const localVarPath = `/v1/circles/partners/{partner_id}/sponsorships/validate`.replace(`{${'partner_id'}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (verifyExistingSponsorship !== undefined) {
                localVarQueryParameter['verify_existing_sponsorship'] =
                    verifyExistingSponsorship;
            }
            if (implied !== undefined) {
                localVarQueryParameter['implied'] = implied;
            }
            if (partnerMemberId !== undefined) {
                localVarQueryParameter['partner_member_id'] = partnerMemberId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/circles/partners/{partner_id}/sponsorships/validate`,
                sdkMethod: 'v1ValidatePartnerEligibility',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(circleSponsorshipEligibilityRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.CircleApiAxiosParamCreator = CircleApiAxiosParamCreator;
/**
 * CircleApi - functional programming interface
 * @export
 */
const CircleApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.CircleApiAxiosParamCreator)(configuration);
    return {
        /**
         * Creates a circle relationship. This endpoint requires admin permissions. |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @param {number} recipientId A ID of the recipient self circle
         * @param {CircleCreateRelationshipRequest} circleCreateRelationshipRequest Create circle relationship request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCircleRelationshipV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createCircleRelationshipV1(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | d |
         * @summary Deletes a circle and all resources associated with it: activities, documents, medications, and polls.
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCircle(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteCircle(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Deletes a circle relationship by caregiver user id. Permissions required: |Feature|Dataclass|Permission| |-------|---------|----------| | - | careteam | d |
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} caregiverId Circle Relationship Caregiver User ID.
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCircleRelationshipByCaregiverV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteCircleRelationshipByCaregiverV1(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | careteam | d |
         * @summary Removes other relationship from a circle if there is permissions to do so. A member with s permission can remove anyone and a member with d permission can remove non s relationships.
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} relationshipId Circle Relationship ID.
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCircleRelationshipForOthersV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteCircleRelationshipForOthersV1(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | e |
         * @summary Deletes a circle permanently and all resources associated with it
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expungeCircleV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.expungeCircleV1(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | w |
         * @summary Extend the sponsorship for the recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} partnerId The ID of the partner
         * @param {string} sponsorshipId The ID of the sponsorship
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extendSponsorship(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.extendSponsorship(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Returns a circle by recipient id
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {boolean} [includePastRelation] when true, the result will contain relationships where a user left the circle.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCircleById(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCircleById(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Get cohort configurations for a circle
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {boolean} [includeDeleted] when true, the result will contain soft deleted circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCircleCohortV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCircleCohortV1(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * The endpoint populates the information first using member\'s self circle information. If the information is not available on self circle, then it calls the identity service to fetch account level information and uses that. |Feature|Dataclass|Permission| |-------|---------|----------| | - | careteam | r |
         * @summary Returns members of a circle which includes recipient & caregivers
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {boolean} [includePastMembers] Includes past members who were removed from caregiver team. Defaults to false.
         * @param {boolean} [includeDeleted] when true, the result will contain soft deleted circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCircleMembers(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCircleMembers(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Get unsponsored config
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCircleUnsponsoredConfig(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCircleUnsponsoredConfig(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Returns circles for the current user
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} [userId] This field can be used if the target user is different than the current user. Requires read permission. If ignored returns circles for the current user.
         * @param {string} [cohort] If provided, the result will contain circles from that cohort only.
         * @param {boolean} [includePastRelation] when true, the result will contain relationships where a user left the circle.
         * @param {boolean} [includeDeleted] When set true, the result will contain deleted circles in which the user is ACR. Do not pass the variable unless there is a specific requirement to display soft deleted circles.
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [forceRefreshSponsor] Force refresh of circle sponsorships
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCirclesV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCirclesV1(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Returns the cohort configuration.
         * @param {string} name The cohort name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCohortByNameV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCohortByNameV1(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * The API returns config for the most recent sponsorship for the recipient along with sponsor details. Note that the most recent sponsorship can be terminated due to eligibility loss. The API returns the most recent sponsorship data to allow for the copy circle flow that needs to be triggered after the loss of sponsorship. |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Returns details about the most recent sponsorship
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMostRecentSponsorship(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMostRecentSponsorship(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - | This endpoint will return the partner member for the given partner id and search criteria. This endpoint is only accessible to admin users. Note that every partner has a different set of search criteria.  Search criteria can be by: - validation fields like partnerId + (email, firstName, lastName, dob, subscriberId). - partner specific fields like partnerId + (memberId).
         * @summary Gets Partners Member as admin by partner id and search criteria.
         * @param {string} partnerId The ID of the partner
         * @param {string} [memberId] Id of the member to search
         * @param {string} [email] Email of the member to search
         * @param {string} [firstName] First name of the member to search
         * @param {string} [lastName] Last name of the member to search
         * @param {string} [dob] Date of birth of the member to search.  full-date notation as defined by [RFC 3339, section 5.6](https://datatracker.ietf.org/doc/html/rfc3339#section-5.6), for example, 2017-07-21
         * @param {string} [subscriberId] SubscriberId of the member to search.
         * @param {string} [partnerMemberId] Id of the member in the partner system saved in our DB to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerMemberAsAdmin(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPartnerMemberAsAdmin(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Returns Partners config by uniq code
         * @param {string} uniqCode Partner Unique Code
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnersConfigByUniqCode(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPartnersConfigByUniqCode(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |  This endpoint will return the partner config for the given uniq code. This endpoint is only accessible to admin users. After you got the partner config, you can use the partner_id to call the other endpoints. E.g. [/v1/partners/{partner_id}/members/search](https://apidoc.evexiaapp.site/#/circle/getPartnerMemberAsAdmin) to find member.
         * @summary Returns Partners config as admin by uniq code
         * @param {string} uniqCode Partner Unique Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnersConfigByUniqCodeAsAdmin(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPartnersConfigByUniqCodeAsAdmin(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Returns a list of referrals associated with the query params
         * @param {number} recipientId A ID of the recipient self circle
         * @param {Array<string>} referralId The Referral ID array sent in the form referral_id&#x3D;a&amp;referral_id&#x3D;b&amp;..
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {string} [partnerId] The ID of the partner, required to fetch sponsored referral, else unsponsored referral returned.
         * @param {string} [sponsorshipConfigId] The Sponsorship Config ID, required to fetch sponsored referral, else unsponsored referral returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferrals(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getReferrals(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Get health resources for the given Circle\'s Sponsorship
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {Array<string>} [themes] List of themes to filter the resources by.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResources(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getResources(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |  This endpoint will return an array of sponsors for the given member id. This endpoint is only accessible to admin users. After you got the list of sponsors, you may attach the response to other admin endpoints.
         * @summary Returns non-removed Sponsors for a given Member ID
         * @param {string} memberId The ID of the member
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSponsorsByMemberIDAsAdmin(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSponsorsByMemberIDAsAdmin(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Returns circle by id for the user.
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} userId This field can be used if the target user is different than the current user. Requires read permission.
         * @param {boolean} [includePastRelation] when true, the result will contain relationships where a user left the circle.
         * @param {boolean} [includeDeleted] when true, the result will contain soft deleted circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersCirclesRecipientV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUsersCirclesRecipientV1(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Returns circle summaries for the current user
         * @param {string} userId This field can be used if the target user is different than the current user. Requires read permission. If ignored returns circles for the current user.
         * @param {string} [cohort] If provided, the result will contain circles from that cohort only.
         * @param {'true' | 'false'} [includeRecipientIdsJWT] If true the response contains recipient IDs JWT which can be used for batch queries.
         * @param {boolean} [includeDeleted] when true, the result will contain soft deleted circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersCirclesV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUsersCirclesV1(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Removes a relationship representing the member from a circle for the member calling the endpoint
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveCircleRelationship(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.leaveCircleRelationship(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | careteam | u |
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} relationshipId Circle Relationship ID.
         * @param {CirclePatchRelationshipRequest} circlePatchRelationshipRequest Patch Circle Relationship
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCircleRelationshipV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.patchCircleRelationshipV1(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Allows caregivers to edit certain fields of their circle relationship. |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @param {number} recipientId A ID of the recipient self circle
         * @param {CirclePatchSelfRelationshipRequest} circlePatchSelfRelationshipRequest Patch Self Circle Relationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchSelfCircleRelationshipV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.patchSelfCircleRelationshipV1(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Creates a circle with current user as the specified role.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {CircleCreateCircleRequest} circleCreateCircleRequest Create circle request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCirclesV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.postCirclesV1(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | role | u |
         * @summary Updates the role of the user to the new role in the circle.
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} relationshipId The caregivers relationship id whose role needs to be changed.
         * @param {string} newRole The new role that user should belong to. Only one of the roles allowed in the circle can be used.
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCircleUserRoleV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateCircleUserRoleV1(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | w |
         * @summary Updates a user\'s consents
         * @param {number} recipientId A ID of the recipient self circle
         * @param {CircleUpdateUserConsentRequest} circleUpdateUserConsentRequest Consents to update
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserConsents(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateUserConsents(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | u |
         * @summary Changes a sponsor for a recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} partnerId The ID of the partner
         * @param {CircleChangeSponsorshipRequest} circleChangeSponsorshipRequest Change sponsorship request.
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ChangeSponsor(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ChangeSponsor(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Admin Only - Sets the cohort for a circle. Admin only access
         * @param {number} recipientId A ID of the recipient self circle
         * @param {CircleUpdateCircleRequest} circleUpdateCircleRequest Create circle request
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1CirclesRecipientIdPatch(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1CirclesRecipientIdPatch(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * The API does the following: 1a. saves provided consent in the post body to the recipient_id 1b. copies the circle data of recipient_id to a new_recipient_id, and saves the parent recipient_id in DB for the new_recipient_id. 1c. soft deletes the data of recipient_id 2. call copy endpoint on all the services with old and new recipient_id  If there is an error in step 2, it tries to revert the step 1. Any error in revert operation is ignored and leaves the user data in inconsistent state that needs to be handled manually.  On success operation, the clients can call the getCircles API to fetch latest circle data and tokens as usual. |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | c |
         * @summary copyCircle
         * @param {number} recipientId A ID of the recipient self circle
         * @param {CircleCopyRequest} circleCopyRequest
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1CopyCircle(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1CopyCircle(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | d |
         * @summary Deletes a sponsor for a recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} partnerId The ID of the partner
         * @param {string} sponsorshipId The ID of the sponsorship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DeleteSponsor(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1DeleteSponsor(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * The API refreshes sponsorship by fetching new member data from eligibility source. The cohort/perms can changed. The recipient can lose sponsorship in which case the response will have no sponsor object on the circle. The API is cached and uses cached data till expiry, unless forceRefresh flag is used. |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | w |
         * @summary Refreshes sponsor for recipient
         * @param {string} partnerId The ID of the partner
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [forceRefresh] Force refresh by excluding cache
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RefreshSponsorship(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1RefreshSponsorship(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Validates the given input based on the type of eligibility source. Determines the sponsorship based on partner and assigns one to the member. The Sponsorship Config ID in the response can be used to get the partner+sponsorship level configurations like logo etc. The API can be called in following scenarios:  1. User is registering for the first time and wants a sponsor.  2. User has already registered as d2c cohort and is now trying to pickup their first sponsorship.  3. User has already registered as sponsored cohort and is now trying to change their sponsorship to something else.  For invitation-based sponsorships, the request body should contain an `invite_code` validation field: { \"name\":\"invite_code\", \"value\":\"1D7EXXIPO\" }  |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | w |
         * @summary validates input and assign sponsorship
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} partnerId The ID of the partner
         * @param {CircleValidateAndAssignSponsorshipRequest} circleValidateAndAssignSponsorshipRequest Invite request
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ValidateAndAssignSponsorship(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ValidateAndAssignSponsorship(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Validates whether the given data is eligible for sponsorship by the partner based on the Partner\'s Eligiblty Source. This endpoint does not assign a sponsorship to the user, and is only used to check for sponsorship eligibility.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary validates user eligibilty for partner sponsorship
         * @param {string} partnerId The ID of the partner
         * @param {CircleSponsorshipEligibilityRequest} circleSponsorshipEligibilityRequest Eligibility Validation Request
         * @param {boolean} [verifyExistingSponsorship] This field is used to check if the target user is different than the current redeemed user. Requires read permission. If ignored returns member for the current user.
         * @param {boolean} [implied] When true, the API will upsert a record for eligibility using the provided eligibility fields. The partner_member_id/partner_user_id is the subject/user_id of the user who called the API. The eligibility fields from the ssoData in the Auth Token is used and not the one sent in the POST body to make sure the data is not tampered with. For admin, the eligibility fields are taken from the POST body and a partner_member_id query param can be sent.
         * @param {string} [partnerMemberId] Admin only. When implied&#x3D;true, the API will upsert a record for eligibility using the provided eligibility fields. The partner_member_id/partner_user_id is the subject/user_id of the user who called the API. The eligibility fields from the ssoData in the Auth Token is used and not the one sent in the POST body to make sure the data is not tampered with. For admin, the eligibility fields are taken from the POST body and a partner_member_id query param is used as partner_user_id/partner_member_id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ValidatePartnerEligibility(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ValidatePartnerEligibility(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.CircleApiFp = CircleApiFp;
/**
 * CircleApi - factory interface
 * @export
 */
const CircleApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.CircleApiFp)(configuration);
    return {
        /**
         * Creates a circle relationship. This endpoint requires admin permissions. |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @param {number} recipientId A ID of the recipient self circle
         * @param {CircleCreateRelationshipRequest} circleCreateRelationshipRequest Create circle relationship request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCircleRelationshipV1(params, options) {
            return localVarFp
                .createCircleRelationshipV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | d |
         * @summary Deletes a circle and all resources associated with it: activities, documents, medications, and polls.
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCircle(params, options) {
            return localVarFp
                .deleteCircle(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Deletes a circle relationship by caregiver user id. Permissions required: |Feature|Dataclass|Permission| |-------|---------|----------| | - | careteam | d |
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} caregiverId Circle Relationship Caregiver User ID.
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCircleRelationshipByCaregiverV1(params, options) {
            return localVarFp
                .deleteCircleRelationshipByCaregiverV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | careteam | d |
         * @summary Removes other relationship from a circle if there is permissions to do so. A member with s permission can remove anyone and a member with d permission can remove non s relationships.
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} relationshipId Circle Relationship ID.
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCircleRelationshipForOthersV1(params, options) {
            return localVarFp
                .deleteCircleRelationshipForOthersV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | e |
         * @summary Deletes a circle permanently and all resources associated with it
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expungeCircleV1(params, options) {
            return localVarFp
                .expungeCircleV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | w |
         * @summary Extend the sponsorship for the recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} partnerId The ID of the partner
         * @param {string} sponsorshipId The ID of the sponsorship
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extendSponsorship(params, options) {
            return localVarFp
                .extendSponsorship(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Returns a circle by recipient id
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {boolean} [includePastRelation] when true, the result will contain relationships where a user left the circle.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCircleById(params, options) {
            return localVarFp
                .getCircleById(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Get cohort configurations for a circle
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {boolean} [includeDeleted] when true, the result will contain soft deleted circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCircleCohortV1(params, options) {
            return localVarFp
                .getCircleCohortV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * The endpoint populates the information first using member\'s self circle information. If the information is not available on self circle, then it calls the identity service to fetch account level information and uses that. |Feature|Dataclass|Permission| |-------|---------|----------| | - | careteam | r |
         * @summary Returns members of a circle which includes recipient & caregivers
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {boolean} [includePastMembers] Includes past members who were removed from caregiver team. Defaults to false.
         * @param {boolean} [includeDeleted] when true, the result will contain soft deleted circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCircleMembers(params, options) {
            return localVarFp
                .getCircleMembers(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Get unsponsored config
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCircleUnsponsoredConfig(params, options) {
            return localVarFp
                .getCircleUnsponsoredConfig(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Returns circles for the current user
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} [userId] This field can be used if the target user is different than the current user. Requires read permission. If ignored returns circles for the current user.
         * @param {string} [cohort] If provided, the result will contain circles from that cohort only.
         * @param {boolean} [includePastRelation] when true, the result will contain relationships where a user left the circle.
         * @param {boolean} [includeDeleted] When set true, the result will contain deleted circles in which the user is ACR. Do not pass the variable unless there is a specific requirement to display soft deleted circles.
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [forceRefreshSponsor] Force refresh of circle sponsorships
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCirclesV1(params, options) {
            return localVarFp
                .getCirclesV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Returns the cohort configuration.
         * @param {string} name The cohort name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCohortByNameV1(params, options) {
            return localVarFp
                .getCohortByNameV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * The API returns config for the most recent sponsorship for the recipient along with sponsor details. Note that the most recent sponsorship can be terminated due to eligibility loss. The API returns the most recent sponsorship data to allow for the copy circle flow that needs to be triggered after the loss of sponsorship. |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Returns details about the most recent sponsorship
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMostRecentSponsorship(params, options) {
            return localVarFp
                .getMostRecentSponsorship(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - | This endpoint will return the partner member for the given partner id and search criteria. This endpoint is only accessible to admin users. Note that every partner has a different set of search criteria.  Search criteria can be by: - validation fields like partnerId + (email, firstName, lastName, dob, subscriberId). - partner specific fields like partnerId + (memberId).
         * @summary Gets Partners Member as admin by partner id and search criteria.
         * @param {string} partnerId The ID of the partner
         * @param {string} [memberId] Id of the member to search
         * @param {string} [email] Email of the member to search
         * @param {string} [firstName] First name of the member to search
         * @param {string} [lastName] Last name of the member to search
         * @param {string} [dob] Date of birth of the member to search.  full-date notation as defined by [RFC 3339, section 5.6](https://datatracker.ietf.org/doc/html/rfc3339#section-5.6), for example, 2017-07-21
         * @param {string} [subscriberId] SubscriberId of the member to search.
         * @param {string} [partnerMemberId] Id of the member in the partner system saved in our DB to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerMemberAsAdmin(params, options) {
            return localVarFp
                .getPartnerMemberAsAdmin(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Returns Partners config by uniq code
         * @param {string} uniqCode Partner Unique Code
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnersConfigByUniqCode(params, options) {
            return localVarFp
                .getPartnersConfigByUniqCode(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |  This endpoint will return the partner config for the given uniq code. This endpoint is only accessible to admin users. After you got the partner config, you can use the partner_id to call the other endpoints. E.g. [/v1/partners/{partner_id}/members/search](https://apidoc.evexiaapp.site/#/circle/getPartnerMemberAsAdmin) to find member.
         * @summary Returns Partners config as admin by uniq code
         * @param {string} uniqCode Partner Unique Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnersConfigByUniqCodeAsAdmin(params, options) {
            return localVarFp
                .getPartnersConfigByUniqCodeAsAdmin(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Returns a list of referrals associated with the query params
         * @param {number} recipientId A ID of the recipient self circle
         * @param {Array<string>} referralId The Referral ID array sent in the form referral_id&#x3D;a&amp;referral_id&#x3D;b&amp;..
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {string} [partnerId] The ID of the partner, required to fetch sponsored referral, else unsponsored referral returned.
         * @param {string} [sponsorshipConfigId] The Sponsorship Config ID, required to fetch sponsored referral, else unsponsored referral returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferrals(params, options) {
            return localVarFp
                .getReferrals(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Get health resources for the given Circle\'s Sponsorship
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {Array<string>} [themes] List of themes to filter the resources by.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResources(params, options) {
            return localVarFp
                .getResources(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |  This endpoint will return an array of sponsors for the given member id. This endpoint is only accessible to admin users. After you got the list of sponsors, you may attach the response to other admin endpoints.
         * @summary Returns non-removed Sponsors for a given Member ID
         * @param {string} memberId The ID of the member
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSponsorsByMemberIDAsAdmin(params, options) {
            return localVarFp
                .getSponsorsByMemberIDAsAdmin(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Returns circle by id for the user.
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} userId This field can be used if the target user is different than the current user. Requires read permission.
         * @param {boolean} [includePastRelation] when true, the result will contain relationships where a user left the circle.
         * @param {boolean} [includeDeleted] when true, the result will contain soft deleted circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersCirclesRecipientV1(params, options) {
            return localVarFp
                .getUsersCirclesRecipientV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Returns circle summaries for the current user
         * @param {string} userId This field can be used if the target user is different than the current user. Requires read permission. If ignored returns circles for the current user.
         * @param {string} [cohort] If provided, the result will contain circles from that cohort only.
         * @param {'true' | 'false'} [includeRecipientIdsJWT] If true the response contains recipient IDs JWT which can be used for batch queries.
         * @param {boolean} [includeDeleted] when true, the result will contain soft deleted circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersCirclesV1(params, options) {
            return localVarFp
                .getUsersCirclesV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Removes a relationship representing the member from a circle for the member calling the endpoint
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveCircleRelationship(params, options) {
            return localVarFp
                .leaveCircleRelationship(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | careteam | u |
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} relationshipId Circle Relationship ID.
         * @param {CirclePatchRelationshipRequest} circlePatchRelationshipRequest Patch Circle Relationship
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCircleRelationshipV1(params, options) {
            return localVarFp
                .patchCircleRelationshipV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Allows caregivers to edit certain fields of their circle relationship. |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @param {number} recipientId A ID of the recipient self circle
         * @param {CirclePatchSelfRelationshipRequest} circlePatchSelfRelationshipRequest Patch Self Circle Relationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchSelfCircleRelationshipV1(params, options) {
            return localVarFp
                .patchSelfCircleRelationshipV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Creates a circle with current user as the specified role.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {CircleCreateCircleRequest} circleCreateCircleRequest Create circle request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCirclesV1(params, options) {
            return localVarFp
                .postCirclesV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | role | u |
         * @summary Updates the role of the user to the new role in the circle.
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} relationshipId The caregivers relationship id whose role needs to be changed.
         * @param {string} newRole The new role that user should belong to. Only one of the roles allowed in the circle can be used.
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCircleUserRoleV1(params, options) {
            return localVarFp
                .updateCircleUserRoleV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | w |
         * @summary Updates a user\'s consents
         * @param {number} recipientId A ID of the recipient self circle
         * @param {CircleUpdateUserConsentRequest} circleUpdateUserConsentRequest Consents to update
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserConsents(params, options) {
            return localVarFp
                .updateUserConsents(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | u |
         * @summary Changes a sponsor for a recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} partnerId The ID of the partner
         * @param {CircleChangeSponsorshipRequest} circleChangeSponsorshipRequest Change sponsorship request.
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ChangeSponsor(params, options) {
            return localVarFp
                .v1ChangeSponsor(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Admin Only - Sets the cohort for a circle. Admin only access
         * @param {number} recipientId A ID of the recipient self circle
         * @param {CircleUpdateCircleRequest} circleUpdateCircleRequest Create circle request
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1CirclesRecipientIdPatch(params, options) {
            return localVarFp
                .v1CirclesRecipientIdPatch(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * The API does the following: 1a. saves provided consent in the post body to the recipient_id 1b. copies the circle data of recipient_id to a new_recipient_id, and saves the parent recipient_id in DB for the new_recipient_id. 1c. soft deletes the data of recipient_id 2. call copy endpoint on all the services with old and new recipient_id  If there is an error in step 2, it tries to revert the step 1. Any error in revert operation is ignored and leaves the user data in inconsistent state that needs to be handled manually.  On success operation, the clients can call the getCircles API to fetch latest circle data and tokens as usual. |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | c |
         * @summary copyCircle
         * @param {number} recipientId A ID of the recipient self circle
         * @param {CircleCopyRequest} circleCopyRequest
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1CopyCircle(params, options) {
            return localVarFp
                .v1CopyCircle(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | d |
         * @summary Deletes a sponsor for a recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} partnerId The ID of the partner
         * @param {string} sponsorshipId The ID of the sponsorship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DeleteSponsor(params, options) {
            return localVarFp
                .v1DeleteSponsor(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * The API refreshes sponsorship by fetching new member data from eligibility source. The cohort/perms can changed. The recipient can lose sponsorship in which case the response will have no sponsor object on the circle. The API is cached and uses cached data till expiry, unless forceRefresh flag is used. |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | w |
         * @summary Refreshes sponsor for recipient
         * @param {string} partnerId The ID of the partner
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [forceRefresh] Force refresh by excluding cache
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RefreshSponsorship(params, options) {
            return localVarFp
                .v1RefreshSponsorship(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Validates the given input based on the type of eligibility source. Determines the sponsorship based on partner and assigns one to the member. The Sponsorship Config ID in the response can be used to get the partner+sponsorship level configurations like logo etc. The API can be called in following scenarios:  1. User is registering for the first time and wants a sponsor.  2. User has already registered as d2c cohort and is now trying to pickup their first sponsorship.  3. User has already registered as sponsored cohort and is now trying to change their sponsorship to something else.  For invitation-based sponsorships, the request body should contain an `invite_code` validation field: { \"name\":\"invite_code\", \"value\":\"1D7EXXIPO\" }  |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | w |
         * @summary validates input and assign sponsorship
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} partnerId The ID of the partner
         * @param {CircleValidateAndAssignSponsorshipRequest} circleValidateAndAssignSponsorshipRequest Invite request
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ValidateAndAssignSponsorship(params, options) {
            return localVarFp
                .v1ValidateAndAssignSponsorship(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Validates whether the given data is eligible for sponsorship by the partner based on the Partner\'s Eligiblty Source. This endpoint does not assign a sponsorship to the user, and is only used to check for sponsorship eligibility.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary validates user eligibilty for partner sponsorship
         * @param {string} partnerId The ID of the partner
         * @param {CircleSponsorshipEligibilityRequest} circleSponsorshipEligibilityRequest Eligibility Validation Request
         * @param {boolean} [verifyExistingSponsorship] This field is used to check if the target user is different than the current redeemed user. Requires read permission. If ignored returns member for the current user.
         * @param {boolean} [implied] When true, the API will upsert a record for eligibility using the provided eligibility fields. The partner_member_id/partner_user_id is the subject/user_id of the user who called the API. The eligibility fields from the ssoData in the Auth Token is used and not the one sent in the POST body to make sure the data is not tampered with. For admin, the eligibility fields are taken from the POST body and a partner_member_id query param can be sent.
         * @param {string} [partnerMemberId] Admin only. When implied&#x3D;true, the API will upsert a record for eligibility using the provided eligibility fields. The partner_member_id/partner_user_id is the subject/user_id of the user who called the API. The eligibility fields from the ssoData in the Auth Token is used and not the one sent in the POST body to make sure the data is not tampered with. For admin, the eligibility fields are taken from the POST body and a partner_member_id query param is used as partner_user_id/partner_member_id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ValidatePartnerEligibility(params, options) {
            return localVarFp
                .v1ValidatePartnerEligibility(params, options)
                .then((request) => request(axios, basePath));
        },
    };
};
exports.CircleApiFactory = CircleApiFactory;
/**
 * CircleApi - object-oriented interface
 * @export
 * @class CircleApi
 * @extends {BaseAPI}
 */
class CircleApi extends base_1.BaseAPI {
    /**
     * URL `/v1/circles/{recipient_id}/relationships`
     * Creates a circle relationship. This endpoint requires admin permissions. |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @param {number} recipientId A ID of the recipient self circle
     * @param {CircleCreateRelationshipRequest} circleCreateRelationshipRequest Create circle relationship request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CircleApi
     */
    createCircleRelationshipV1(params, options) {
        return (0, exports.CircleApiFp)(this.configuration)
            .createCircleRelationshipV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/circles/{recipient_id}`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | d |
     * @summary Deletes a circle and all resources associated with it: activities, documents, medications, and polls.
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CircleApi
     */
    deleteCircle(params, options) {
        return (0, exports.CircleApiFp)(this.configuration)
            .deleteCircle(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/circles/{recipient_id}/caregivers/{caregiver_id}`
     * Deletes a circle relationship by caregiver user id. Permissions required: |Feature|Dataclass|Permission| |-------|---------|----------| | - | careteam | d |
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} caregiverId Circle Relationship Caregiver User ID.
     * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CircleApi
     */
    deleteCircleRelationshipByCaregiverV1(params, options) {
        return (0, exports.CircleApiFp)(this.configuration)
            .deleteCircleRelationshipByCaregiverV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/circles/{recipient_id}/relationships/{relationship_id}`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | careteam | d |
     * @summary Removes other relationship from a circle if there is permissions to do so. A member with s permission can remove anyone and a member with d permission can remove non s relationships.
     * @param {number} recipientId A ID of the recipient self circle
     * @param {number} relationshipId Circle Relationship ID.
     * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CircleApi
     */
    deleteCircleRelationshipForOthersV1(params, options) {
        return (0, exports.CircleApiFp)(this.configuration)
            .deleteCircleRelationshipForOthersV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/circles/{recipient_id}/expunge`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | e |
     * @summary Deletes a circle permanently and all resources associated with it
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CircleApi
     */
    expungeCircleV1(params, options) {
        return (0, exports.CircleApiFp)(this.configuration)
            .expungeCircleV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/circles/{recipient_id}/partners/{partner_id}/sponsorships/{sponsorship_id}/extend`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | w |
     * @summary Extend the sponsorship for the recipient
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} partnerId The ID of the partner
     * @param {string} sponsorshipId The ID of the sponsorship
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CircleApi
     */
    extendSponsorship(params, options) {
        return (0, exports.CircleApiFp)(this.configuration)
            .extendSponsorship(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/circles/{recipient_id}`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
     * @summary Returns a circle by recipient id
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
     * @param {boolean} [includePastRelation] when true, the result will contain relationships where a user left the circle.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CircleApi
     */
    getCircleById(params, options) {
        return (0, exports.CircleApiFp)(this.configuration)
            .getCircleById(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/circles/{recipient_id}/cohort`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
     * @summary Get cohort configurations for a circle
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
     * @param {boolean} [includeDeleted] when true, the result will contain soft deleted circle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CircleApi
     */
    getCircleCohortV1(params, options) {
        return (0, exports.CircleApiFp)(this.configuration)
            .getCircleCohortV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/circles/{recipient_id}/members`
     * The endpoint populates the information first using member\'s self circle information. If the information is not available on self circle, then it calls the identity service to fetch account level information and uses that. |Feature|Dataclass|Permission| |-------|---------|----------| | - | careteam | r |
     * @summary Returns members of a circle which includes recipient & caregivers
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
     * @param {boolean} [includePastMembers] Includes past members who were removed from caregiver team. Defaults to false.
     * @param {boolean} [includeDeleted] when true, the result will contain soft deleted circle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CircleApi
     */
    getCircleMembers(params, options) {
        return (0, exports.CircleApiFp)(this.configuration)
            .getCircleMembers(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/circles/configs/unsponsored`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Get unsponsored config
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CircleApi
     */
    getCircleUnsponsoredConfig(params, options) {
        return (0, exports.CircleApiFp)(this.configuration)
            .getCircleUnsponsoredConfig(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/circles`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Returns circles for the current user
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} [userId] This field can be used if the target user is different than the current user. Requires read permission. If ignored returns circles for the current user.
     * @param {string} [cohort] If provided, the result will contain circles from that cohort only.
     * @param {boolean} [includePastRelation] when true, the result will contain relationships where a user left the circle.
     * @param {boolean} [includeDeleted] When set true, the result will contain deleted circles in which the user is ACR. Do not pass the variable unless there is a specific requirement to display soft deleted circles.
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {string} [forceRefreshSponsor] Force refresh of circle sponsorships
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CircleApi
     */
    getCirclesV1(params, options) {
        return (0, exports.CircleApiFp)(this.configuration)
            .getCirclesV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/cohorts/{name}`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Returns the cohort configuration.
     * @param {string} name The cohort name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CircleApi
     */
    getCohortByNameV1(params, options) {
        return (0, exports.CircleApiFp)(this.configuration)
            .getCohortByNameV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/circles/{recipient_id}/sponsorships`
     * The API returns config for the most recent sponsorship for the recipient along with sponsor details. Note that the most recent sponsorship can be terminated due to eligibility loss. The API returns the most recent sponsorship data to allow for the copy circle flow that needs to be triggered after the loss of sponsorship. |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
     * @summary Returns details about the most recent sponsorship
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CircleApi
     */
    getMostRecentSponsorship(params, options) {
        return (0, exports.CircleApiFp)(this.configuration)
            .getMostRecentSponsorship(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/partners/{partner_id}/members/search`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - | This endpoint will return the partner member for the given partner id and search criteria. This endpoint is only accessible to admin users. Note that every partner has a different set of search criteria.  Search criteria can be by: - validation fields like partnerId + (email, firstName, lastName, dob, subscriberId). - partner specific fields like partnerId + (memberId).
     * @summary Gets Partners Member as admin by partner id and search criteria.
     * @param {string} partnerId The ID of the partner
     * @param {string} [memberId] Id of the member to search
     * @param {string} [email] Email of the member to search
     * @param {string} [firstName] First name of the member to search
     * @param {string} [lastName] Last name of the member to search
     * @param {string} [dob] Date of birth of the member to search.  full-date notation as defined by [RFC 3339, section 5.6](https://datatracker.ietf.org/doc/html/rfc3339#section-5.6), for example, 2017-07-21
     * @param {string} [subscriberId] SubscriberId of the member to search.
     * @param {string} [partnerMemberId] Id of the member in the partner system saved in our DB to search
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CircleApi
     */
    getPartnerMemberAsAdmin(params, options) {
        return (0, exports.CircleApiFp)(this.configuration)
            .getPartnerMemberAsAdmin(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/circles/{recipient_id}/partners/codes/{uniq_code}`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
     * @summary Returns Partners config by uniq code
     * @param {string} uniqCode Partner Unique Code
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CircleApi
     */
    getPartnersConfigByUniqCode(params, options) {
        return (0, exports.CircleApiFp)(this.configuration)
            .getPartnersConfigByUniqCode(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/partners/codes/{uniq_code}`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |  This endpoint will return the partner config for the given uniq code. This endpoint is only accessible to admin users. After you got the partner config, you can use the partner_id to call the other endpoints. E.g. [/v1/partners/{partner_id}/members/search](https://apidoc.evexiaapp.site/#/circle/getPartnerMemberAsAdmin) to find member.
     * @summary Returns Partners config as admin by uniq code
     * @param {string} uniqCode Partner Unique Code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CircleApi
     */
    getPartnersConfigByUniqCodeAsAdmin(params, options) {
        return (0, exports.CircleApiFp)(this.configuration)
            .getPartnersConfigByUniqCodeAsAdmin(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/circles/{recipient_id}/referrals`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
     * @summary Returns a list of referrals associated with the query params
     * @param {number} recipientId A ID of the recipient self circle
     * @param {Array<string>} referralId The Referral ID array sent in the form referral_id&#x3D;a&amp;referral_id&#x3D;b&amp;..
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
     * @param {string} [partnerId] The ID of the partner, required to fetch sponsored referral, else unsponsored referral returned.
     * @param {string} [sponsorshipConfigId] The Sponsorship Config ID, required to fetch sponsored referral, else unsponsored referral returned.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CircleApi
     */
    getReferrals(params, options) {
        return (0, exports.CircleApiFp)(this.configuration)
            .getReferrals(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/circles/{recipient_id}/resources`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
     * @summary Get health resources for the given Circle\'s Sponsorship
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
     * @param {Array<string>} [themes] List of themes to filter the resources by.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CircleApi
     */
    getResources(params, options) {
        return (0, exports.CircleApiFp)(this.configuration)
            .getResources(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/sponsorships/members/{member_id}`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |  This endpoint will return an array of sponsors for the given member id. This endpoint is only accessible to admin users. After you got the list of sponsors, you may attach the response to other admin endpoints.
     * @summary Returns non-removed Sponsors for a given Member ID
     * @param {string} memberId The ID of the member
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CircleApi
     */
    getSponsorsByMemberIDAsAdmin(params, options) {
        return (0, exports.CircleApiFp)(this.configuration)
            .getSponsorsByMemberIDAsAdmin(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/circles/users/{user_id}/circles/{recipient_id}`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Returns circle by id for the user.
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} userId This field can be used if the target user is different than the current user. Requires read permission.
     * @param {boolean} [includePastRelation] when true, the result will contain relationships where a user left the circle.
     * @param {boolean} [includeDeleted] when true, the result will contain soft deleted circle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CircleApi
     */
    getUsersCirclesRecipientV1(params, options) {
        return (0, exports.CircleApiFp)(this.configuration)
            .getUsersCirclesRecipientV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/circles/users/{user_id}/circles`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Returns circle summaries for the current user
     * @param {string} userId This field can be used if the target user is different than the current user. Requires read permission. If ignored returns circles for the current user.
     * @param {string} [cohort] If provided, the result will contain circles from that cohort only.
     * @param {'true' | 'false'} [includeRecipientIdsJWT] If true the response contains recipient IDs JWT which can be used for batch queries.
     * @param {boolean} [includeDeleted] when true, the result will contain soft deleted circle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CircleApi
     */
    getUsersCirclesV1(params, options) {
        return (0, exports.CircleApiFp)(this.configuration)
            .getUsersCirclesV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/circles/{recipient_id}/relationships/self`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Removes a relationship representing the member from a circle for the member calling the endpoint
     * @param {number} recipientId A ID of the recipient self circle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CircleApi
     */
    leaveCircleRelationship(params, options) {
        return (0, exports.CircleApiFp)(this.configuration)
            .leaveCircleRelationship(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/circles/{recipient_id}/relationships/{relationship_id}`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | careteam | u |
     * @param {number} recipientId A ID of the recipient self circle
     * @param {number} relationshipId Circle Relationship ID.
     * @param {CirclePatchRelationshipRequest} circlePatchRelationshipRequest Patch Circle Relationship
     * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CircleApi
     */
    patchCircleRelationshipV1(params, options) {
        return (0, exports.CircleApiFp)(this.configuration)
            .patchCircleRelationshipV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/circles/{recipient_id}/relationships/self`
     * Allows caregivers to edit certain fields of their circle relationship. |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @param {number} recipientId A ID of the recipient self circle
     * @param {CirclePatchSelfRelationshipRequest} circlePatchSelfRelationshipRequest Patch Self Circle Relationship
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CircleApi
     */
    patchSelfCircleRelationshipV1(params, options) {
        return (0, exports.CircleApiFp)(this.configuration)
            .patchSelfCircleRelationshipV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/circles`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Creates a circle with current user as the specified role.
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {CircleCreateCircleRequest} circleCreateCircleRequest Create circle request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CircleApi
     */
    postCirclesV1(params, options) {
        return (0, exports.CircleApiFp)(this.configuration)
            .postCirclesV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/circles/{recipient_id}/relationships/{relationship_id}/roles/{new_role}`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | role | u |
     * @summary Updates the role of the user to the new role in the circle.
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} relationshipId The caregivers relationship id whose role needs to be changed.
     * @param {string} newRole The new role that user should belong to. Only one of the roles allowed in the circle can be used.
     * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CircleApi
     */
    updateCircleUserRoleV1(params, options) {
        return (0, exports.CircleApiFp)(this.configuration)
            .updateCircleUserRoleV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/circles/{recipient_id}/consents`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | w |
     * @summary Updates a user\'s consents
     * @param {number} recipientId A ID of the recipient self circle
     * @param {CircleUpdateUserConsentRequest} circleUpdateUserConsentRequest Consents to update
     * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CircleApi
     */
    updateUserConsents(params, options) {
        return (0, exports.CircleApiFp)(this.configuration)
            .updateUserConsents(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/circles/{recipient_id}/partners/{partner_id}/sponsorship`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | u |
     * @summary Changes a sponsor for a recipient
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} partnerId The ID of the partner
     * @param {CircleChangeSponsorshipRequest} circleChangeSponsorshipRequest Change sponsorship request.
     * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CircleApi
     */
    v1ChangeSponsor(params, options) {
        return (0, exports.CircleApiFp)(this.configuration)
            .v1ChangeSponsor(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/circles/{recipient_id}`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Admin Only - Sets the cohort for a circle. Admin only access
     * @param {number} recipientId A ID of the recipient self circle
     * @param {CircleUpdateCircleRequest} circleUpdateCircleRequest Create circle request
     * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CircleApi
     */
    v1CirclesRecipientIdPatch(params, options) {
        return (0, exports.CircleApiFp)(this.configuration)
            .v1CirclesRecipientIdPatch(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/circles/{recipient_id}/copy`
     * The API does the following: 1a. saves provided consent in the post body to the recipient_id 1b. copies the circle data of recipient_id to a new_recipient_id, and saves the parent recipient_id in DB for the new_recipient_id. 1c. soft deletes the data of recipient_id 2. call copy endpoint on all the services with old and new recipient_id  If there is an error in step 2, it tries to revert the step 1. Any error in revert operation is ignored and leaves the user data in inconsistent state that needs to be handled manually.  On success operation, the clients can call the getCircles API to fetch latest circle data and tokens as usual. |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | c |
     * @summary copyCircle
     * @param {number} recipientId A ID of the recipient self circle
     * @param {CircleCopyRequest} circleCopyRequest
     * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CircleApi
     */
    v1CopyCircle(params, options) {
        return (0, exports.CircleApiFp)(this.configuration)
            .v1CopyCircle(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/circles/{recipient_id}/partners/{partner_id}/sponsorships/{sponsorship_config_id}`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | d |
     * @summary Deletes a sponsor for a recipient
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} partnerId The ID of the partner
     * @param {string} sponsorshipId The ID of the sponsorship
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CircleApi
     */
    v1DeleteSponsor(params, options) {
        return (0, exports.CircleApiFp)(this.configuration)
            .v1DeleteSponsor(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/circles/{recipient_id}/partners/{partner_id}/sponsorships/refresh`
     * The API refreshes sponsorship by fetching new member data from eligibility source. The cohort/perms can changed. The recipient can lose sponsorship in which case the response will have no sponsor object on the circle. The API is cached and uses cached data till expiry, unless forceRefresh flag is used. |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | w |
     * @summary Refreshes sponsor for recipient
     * @param {string} partnerId The ID of the partner
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {string} [forceRefresh] Force refresh by excluding cache
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CircleApi
     */
    v1RefreshSponsorship(params, options) {
        return (0, exports.CircleApiFp)(this.configuration)
            .v1RefreshSponsorship(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/circles/{recipient_id}/partners/{partner_id}/sponsorship`
     * Validates the given input based on the type of eligibility source. Determines the sponsorship based on partner and assigns one to the member. The Sponsorship Config ID in the response can be used to get the partner+sponsorship level configurations like logo etc. The API can be called in following scenarios:  1. User is registering for the first time and wants a sponsor.  2. User has already registered as d2c cohort and is now trying to pickup their first sponsorship.  3. User has already registered as sponsored cohort and is now trying to change their sponsorship to something else.  For invitation-based sponsorships, the request body should contain an `invite_code` validation field: { \"name\":\"invite_code\", \"value\":\"1D7EXXIPO\" }  |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | w |
     * @summary validates input and assign sponsorship
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} partnerId The ID of the partner
     * @param {CircleValidateAndAssignSponsorshipRequest} circleValidateAndAssignSponsorshipRequest Invite request
     * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CircleApi
     */
    v1ValidateAndAssignSponsorship(params, options) {
        return (0, exports.CircleApiFp)(this.configuration)
            .v1ValidateAndAssignSponsorship(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/circles/partners/{partner_id}/sponsorships/validate`
     * Validates whether the given data is eligible for sponsorship by the partner based on the Partner\'s Eligiblty Source. This endpoint does not assign a sponsorship to the user, and is only used to check for sponsorship eligibility.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
     * @summary validates user eligibilty for partner sponsorship
     * @param {string} partnerId The ID of the partner
     * @param {CircleSponsorshipEligibilityRequest} circleSponsorshipEligibilityRequest Eligibility Validation Request
     * @param {boolean} [verifyExistingSponsorship] This field is used to check if the target user is different than the current redeemed user. Requires read permission. If ignored returns member for the current user.
     * @param {boolean} [implied] When true, the API will upsert a record for eligibility using the provided eligibility fields. The partner_member_id/partner_user_id is the subject/user_id of the user who called the API. The eligibility fields from the ssoData in the Auth Token is used and not the one sent in the POST body to make sure the data is not tampered with. For admin, the eligibility fields are taken from the POST body and a partner_member_id query param can be sent.
     * @param {string} [partnerMemberId] Admin only. When implied&#x3D;true, the API will upsert a record for eligibility using the provided eligibility fields. The partner_member_id/partner_user_id is the subject/user_id of the user who called the API. The eligibility fields from the ssoData in the Auth Token is used and not the one sent in the POST body to make sure the data is not tampered with. For admin, the eligibility fields are taken from the POST body and a partner_member_id query param is used as partner_user_id/partner_member_id.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CircleApi
     */
    v1ValidatePartnerEligibility(params, options) {
        return (0, exports.CircleApiFp)(this.configuration)
            .v1ValidatePartnerEligibility(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
exports.CircleApi = CircleApi;
//# sourceMappingURL=circle-api.js.map